import PropTypes from "prop-types";

// store
import useBrainStore from "@/store/_brainEmStore";
import useLinkStore from "@/store/_linkStore";

// components
import RadioInput from "@/components/RadioInput/RadioInput";
import Stepper from "@/components/Stepper/Stepper";
import SectionHeading from "@/components/SectionHeading/SectionHeading";

// -----------------------------------------------------------------------------

export default function Projections({ isLinkMode }) {
	// Determine which store hook to use
	const useStore = isLinkMode ? useLinkStore : useBrainStore;

	// Select state individually
	const techProgress = useStore((state) => state.techProgress);
	const investment = useStore((state) => state.investment);
	const yearsToCompletion = useStore((state) => state.yearsToCompletion);

	// Select actions individually
	const setTechProgress = useStore((state) => state.setTechProgress);
	const setInvestment = useStore((state) => state.setInvestment);
	const setYearsToCompletion = useStore((state) => state.setYearsToCompletion);

	// -----------------------------------------------------------------------------

	return (
		<section>
			<SectionHeading heading="Projections" number={5} />

			{/* Technical Progress */}
			<fieldset className="radio-group">
				<legend>Technical Progress</legend>

				<RadioInput
					label="Stagnation"
					value="stagnation"
					name="technical-progress"
					checked={techProgress === "stagnation"}
					onChange={(e) => setTechProgress(e.target.value)}
				/>
				<RadioInput
					label="Linear"
					value="linear"
					name="technical-progress"
					checked={techProgress === "linear"}
					onChange={(e) => setTechProgress(e.target.value)}
				/>
				<RadioInput
					label="Exponential"
					value="exponential"
					name="technical-progress"
					checked={techProgress === "exponential"}
					onChange={(e) => setTechProgress(e.target.value)}
				/>
				<RadioInput
					label="Super-Exponential"
					value="super-exponential"
					name="technical-progress"
					checked={techProgress === "super-exponential"}
					onChange={(e) => setTechProgress(e.target.value)}
				/>
			</fieldset>

			{/* Investment stepper */}
			<Stepper
				label="Upfront Capability Investment [Mil. USD]"
				id="investment"
				value={investment}
				min={0}
				max={10000}
				step={10}
				onChange={setInvestment}
			/>

			{/* Years to Completion stepper */}
			<Stepper
				label="Years to completion of imaging effort"
				id="years-to-completion"
				value={yearsToCompletion}
				min={1}
				max={100}
				step={1}
				onChange={setYearsToCompletion}
			/>
		</section>
	);
}

// -----------------------------------------------------------------------------

Projections.propTypes = {
	isLinkMode: PropTypes.bool.isRequired,
};
